import { useEffect, useState } from "react";

export const CurtainReveal = () => {
  // phase: "show" → "fadeLogo" → "open" → "done"
  // Gated by sessionStorage so it only plays on the first V13 page load of the session.
  const [phase, setPhase] = useState(() => {
    if (typeof window !== "undefined" && window.sessionStorage.getItem("v13-intro-shown")) {
      return "done";
    }
    return "show";
  });

  useEffect(() => {
    // Only schedule the intro animation once, on initial mount.
    if (typeof window !== "undefined" && window.sessionStorage.getItem("v13-intro-shown")) {
      return;
    }
    const t1 = setTimeout(() => setPhase("fadeLogo"), 1000);  // hold logo for 1s
    const t2 = setTimeout(() => setPhase("open"), 1500);      // fade logo out (~500ms), then split curtains
    const t3 = setTimeout(() => {
      setPhase("done");
      try { window.sessionStorage.setItem("v13-intro-shown", "1"); } catch (e) { /* ignore quota/privacy errors */ }
    }, 2800);
    return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3); };
    // Intentionally run only on mount — phase transitions are driven by the timeouts above.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (phase === "done") return null;
  const opening = phase === "open";
  const logoVisible = phase === "show"; // fully visible only during show; fades in fadeLogo + open

  return (
    <div className="fixed inset-0 z-[500] pointer-events-none overflow-hidden" data-testid="v13-curtain-reveal">
      {/* Top curtain */}
      <div
        className="absolute inset-x-0 top-0 h-1/2 bg-[#0A4F3B]"
        style={{
          transform: opening ? "translateY(-100%)" : "translateY(0)",
          transition: "transform 1.2s cubic-bezier(0.76, 0, 0.24, 1)",
          willChange: "transform",
        }}
      />

      {/* Bottom curtain */}
      <div
        className="absolute inset-x-0 bottom-0 h-1/2 bg-[#0A4F3B]"
        style={{
          transform: opening ? "translateY(100%)" : "translateY(0)",
          transition: "transform 1.2s cubic-bezier(0.76, 0, 0.24, 1)",
          willChange: "transform",
        }}
      />

      {/* Logo — independent layer, centered, fades out before curtains open */}
      <div className="absolute inset-0 flex items-center justify-center z-10 pointer-events-none">
        <img
          src="/gillco-logo-white.png"
          alt="Gillco"
          className="w-[260px] sm:w-[320px] lg:w-[400px] h-auto block select-none"
          style={{
            opacity: logoVisible ? 1 : 0,
            transition: "opacity 0.5s ease",
          }}
          draggable={false}
        />
      </div>
    </div>
  );
};